import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import MoreActionMenu from "./MoreActionMenu";
import "./userdetailsheader.scss";
import "./testModule/measurementFlow.scss";
import { userInfoFetch, formatName } from "../../utlis/commonFunction";
import { getCurrentLocale } from "../../utlis/locale";
import { genderLabel } from "../../utlis/genderLabel";
import InitialsAvatar from "../plugInElements/InitialsAvatar";
import { buildSessionPath, getStoredSession } from "../mmtUserList/mmtFlow";
import { USER_LIST } from "../../routes/routerPath";
import { useSection } from "../../i18n/useSection";

const UserDetailsHeader = ({
  children,
  removeReportId,
  person,
  className = "measurement-shell",
  onBack,
  backLabel,
}) => {
  const userInfo = person === undefined ? userInfoFetch() : person;
  const { back } = useSection("common");
  const navigate = useNavigate();
  const urlPath = window.location.pathname;
  const backArrowHandler = () => {
    // Go back within the SPA history; when this page was the entry point
    // (no history), fall back to the user list so the button never dead-ends.
    if ((window.history.state?.idx ?? 0) > 0) {
      navigate(-1);
    } else {
      const session = getStoredSession();
      navigate(session ? buildSessionPath(USER_LIST, session) : USER_LIST, {
        replace: true,
      });
    }

    //setting this as empty because once user click back button/ enters from back page. we have generate new reportID
    if (removeReportId) {
      if (urlPath === "/rom-details") {
        sessionStorage.setItem("romReportId", "");
        sessionStorage.setItem("romStatus", "");
      }
    }
  };

  //this useeffect used for clearing session storage, when the user back from browser or phone back
  useEffect(() => {
    if (urlPath === "/test-module") {
      sessionStorage.setItem("romReportId", "");
      sessionStorage.setItem("romStatus", "");
    }
  }, [urlPath]);

  return (
    <div className={`user-detail-menu-wrapper ${className}`}>
      <div className="pinned-header">
        <div className="header-left">
          <button
            className="back-btn"
            onClick={onBack || backArrowHandler}
            aria-label={backLabel || back}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M19 12H5m0 0l7-7m-7 7l7 7"
                stroke="#000000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <div className="user-info">
            <InitialsAvatar
              name={formatName(userInfo, getCurrentLocale())}
              className="user-avatar"
            />
            <div className="user-details">
              <Typography className="user-name">
                {formatName(userInfo, getCurrentLocale())}
              </Typography>
              <Typography className="user-meta">
                {genderLabel(userInfo?.gender)}
                {userInfo?.age > 0 && ` | ${userInfo?.age}`}
              </Typography>
            </div>
          </div>
        </div>
        <div className="header-right">
          <MoreActionMenu userInfo={userInfo} />
        </div>
      </div>

      <div className="user-details-content">{children}</div>
    </div>
  );
};

export default UserDetailsHeader;
